module.exports = __webpack_public_path__ + "img/Fachmann-Leder-Textil-DB-106.a1cf85de.jpg";